import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Button, Dialog, H1, P1R } from 'src/components';
import { InvitationInfoType } from '..';

type InviteUserSuccessDialogProps = {
  theme: 'manager' | 'user';
  open: boolean;
  companyName: string;
  invitationInfo: InvitationInfoType;
  onClose: () => void;
};

const InvitationSentDialog = ({
  theme,
  open,
  companyName,
  invitationInfo: { email: inviteEmail, role, isResendEmail },
  onClose,
}: InviteUserSuccessDialogProps) => {
  const { t } = useTranslation();
  const roleName = role
    .toLowerCase()
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');

  return (
    <Dialog open={open} onClose={onClose}>
      <Box sx={{ paddingY: '44px', gap: '44px', display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
        <H1>{isResendEmail ? t('companyPage.invitationResent') : t('companyPage.invitationSent')}</H1>

        <Box sx={{ gap: '22px', display: 'flex', flexDirection: 'column' }}>
          <P1R>
            A user <b>{inviteEmail}</b> with role {roleName} has been successfully added to <b>{companyName}</b> company.
          </P1R>

          <P1R>
            {theme === 'manager' && t('storm360UsersPage.inviteSystemManagerSuccessSub')}
            {theme === 'user' && t('usersPage.inviteUserSuccessSub')}
          </P1R>
        </Box>

        <Button onClick={onClose} sx={{ width: '235px', textTransform: 'capitalize' }}>
          {t('companyPage.okThanks')}
        </Button>
      </Box>
    </Dialog>
  );
};

export default InvitationSentDialog;
